// src/components/OfflineUpdate/UpdatePanel.tsx
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {setClickable} from "src/store/features/licenseSlice";
import {useFileDownload} from "src/hooks/useFileDownload";
import ProgressBar from "../ProgressBar/ProgressBar";

interface UpdatePanelProps {
    onShowToast: (message: string, isSuccess: boolean) => void;
}

const UpdatePanel: React.FC<UpdatePanelProps> = ({onShowToast}) => {
    const dispatch = useDispatch();
    const [requestData, setRequestData] = useState("");

    const {downloadFile, isDownloading, progress} = useFileDownload({
        onStart: () => dispatch(setClickable(true)),
        onSettled: () => dispatch(setClickable(false)),
        onSuccess: (msg) => onShowToast(msg, true),
        onError: (errMsg) => onShowToast(errMsg, false),
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        downloadFile(requestData);
    };

    return (
        <div className="mt-6 items-center justify-center rounded-lg p-1" id="updateTextarea">
            {isDownloading && progress === 0 ? (
                <p className="text-center mb-7 text-blue-600 font-medium">
                    Size özel güncellemeniz hazırlanıyor... Lütfen sayfayı kapatmayınız.
                </p>
            ) : null}

            {isDownloading && progress > 0 ? (
                <div className="mb-7 flex text-center items-center justify-center">
                    <ProgressBar percent={progress}/>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="w-full mb-4 border border-gray-300 rounded-lg bg-gray-100">
                        <div className="px-4 py-2 bg-white rounded-t-lg">
                            <textarea
                                id="comment"
                                value={requestData}
                                onChange={(e) => setRequestData(e.target.value)}
                                className="w-full h-32 px-0 text-sm text-gray-900 bg-white border-0 focus:ring-0"
                                placeholder="Güncelleme kodunu buraya yapıştırınız"
                                disabled={isDownloading}
                            />
                        </div>
                        <div className="flex flex-col items-end px-3 py-2 border-t">
                            <button
                                id="updateButton"
                                type="submit"
                                disabled={isDownloading}
                                className={`right-0 py-2.5 px-4 text-xs font-medium text-center text-white rounded-lg transition-colors focus:ring-4 focus:ring-blue-200 ${
                                    isDownloading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-700 hover:bg-blue-800'
                                }`}
                            >
                                {isDownloading ? 'İndiriliyor...' : 'Güncelle'}
                            </button>
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
};

export default UpdatePanel;